module.exports = __webpack_public_path__ + "assets/img/logo_b.abd5a177.png";